
APP.select2 = function () {
  if ($(APP.context).is(document) || $(APP.context).is('form') || $('form',APP.context)) {
    $('select',APP.context).each(function() {
      if($(this).hasClass('select2-hidden-accessible')) {
        $(this).select2('destroy');
      }
      $(this).select2({
        width: '100%',
        placeholder: $(this).attr('placeholder') ? $(this).attr('placeholder') : "- Chọn -",
      });
    });
  }

}
